// LOT 22.1 · un chiffre ne se coupe jamais : espaces insécables dans « 6 389,72 MAD », « ≈ 20,4 % », « − 20 ★ », partout dans l'app
const NB = '\u00a0';
const RX = [
  [/(\d)[ \u202f](?=\d{3}(?:\D|$))/g, `$1${NB}`],
  [/(\d(?:[.,]\d+)?)[ ](?=(?:MAD|EUR|USD|€|\$|★|%|h|j|kg|g|L|cl|ml|TTC|HT|pts?)(?![\p{L}]))/gu, `$1${NB}`],
  [/(^|\s)([≈−+\-~<>≤≥])[ ](?=\d)/g, `$1$2${NB}`],
  [/(MAD|EUR|€|★)[ ](?=(?:TTC|HT)\b)/g, `$1${NB}`],
];

// LOT 53 · 0.2 · jamais « & » dans un libellé (« et »), jamais de tiret long : séparateur → « · », valeur absente → « — » + phrase (LOT 55)
const MOTS = [
  [/([\p{L}\d.)])\s*&\s*(?=[\p{L}\d(])/gu, '$1 et '],
  // LOT 55 · une valeur absente reste « — » (seule, ou suivie de « · » et de la phrase qui dit ce qui manque)
  [/\s+—\s*$/, ''],
  [/^\s*—(?!\s*(·|$))\s*/, ''],
  [/(?<=\S)\s*—\s*(?=\S)/g, ' · '],
];
const EMO = /(?!\u2605)[\p{Extended_Pictographic}\u{1F1E6}-\u{1F1FF}]\uFE0F?(?:\u200D[\p{Extended_Pictographic}]\uFE0F?)*/gu;
const AVEC = /[\d&—\u2B51\p{Extended_Pictographic}]/u;
// LOT 74 · un bouton qui coûte des crédits (« Lancer · 60 ★ ») : noir sur jaune, l'étoile à la taille du texte
const COUT = /\p{L}.*\d[\d\u00a0\u202f ]*\u00a0?\s?★/u;
const marque = (t) => { const b = t.parentNode?.closest?.('button, .m-btn, [role="button"]'); if (!b) return; if (COUT.test(b.textContent || '')) b.setAttribute('data-cout-credits', ''); else b.removeAttribute('data-cout-credits'); };
const fixe = (t) => {
  t = t.replace(/\u2B51/g, '★');
  let s = /\d/.test(t) ? RX.reduce((x, [r, v]) => x.replace(r, v), t) : t;
  if (/[&—]/.test(s)) s = MOTS.reduce((x, [r, v]) => x.replace(r, v), s);
  if (/\p{Extended_Pictographic}/u.test(s)) { const n = s.replace(EMO, '').replace(/\uFE0F/g, ''); s = n.trim() ? n.replace(/^\s+(?=\S)/, (m) => (m.length > 1 ? ' ' : m)) : n; }
  return s;
};

const traiter = (node) => {
  if (node.nodeType === 3) {
    const v = node.nodeValue;
    if (v && AVEC.test(v)) { const n = fixe(v); if (n !== v) node.nodeValue = n; marque(node); }
    return;
  }
  if (node.nodeType !== 1 || /^(SCRIPT|STYLE|TEXTAREA|INPUT|OPTION|SELECT)$/.test(node.nodeName) || node.isContentEditable) return;
  const w = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
  for (let t = w.nextNode(); t; t = w.nextNode()) {
    const p = t.parentNode;
    if (p && /^(SCRIPT|STYLE|TEXTAREA|OPTION)$/.test(p.nodeName)) continue;
    const v = t.nodeValue;
    if (v && AVEC.test(v)) { const n = fixe(v); if (n !== v) t.nodeValue = n; marque(t); }
  }
};

export const installerChiffresInsecables = () => {
  if (typeof window === 'undefined' || window.__chiffresNb) return;
  window.__chiffresNb = true;
  const go = () => {
    traiter(document.body);
    new MutationObserver((ms) => ms.forEach((m) => (m.type === 'characterData' ? traiter(m.target) : m.addedNodes.forEach(traiter))))
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.body) go(); else window.addEventListener('DOMContentLoaded', go);
};

export const _test = { fixe };
